import React from 'react'
import { l } from '@manychat/manyui'

export const PhoneNumberRemoved = () => {
  return <span>{l.translate('WhatsApp channel disconnected due to removed phone number')}</span>
}
